import React from "react";
import Topbar from "./Topbar";
import SolicitudList from "./buqueTable";
import Loading from './Loading';

export default function Tickets(props) {
  const currentPath = props.location.pathname;
  const [loading, setLoading] = React.useState(true);

  return (
    <>
      {loading && <Loading color="#00000014" height="100%" width="100%" />}
      <Topbar currentPath={currentPath} />
      <div className="ds-page">
        <SolicitudList setLoading={setLoading} />
      </div>
    </>
  );
}
